
class AnimatedComponent {

    constructor(element, state_list, state_active_list = {}, state_status_list = {}, options = {}) {
        if ( !(element && state_list ) ) {
            return false
        }
        if (state_status_list === null) state_status_list = {}
        if (state_active_list === null) state_active_list = {}
        if (options === null) options = {}
        let options_default = {
            class_prefix: '',
            proccess_suffix: '-process',
            detail: {},
        }

        this._options = {...options_default, ...options}
        if (!(element && element instanceof HTMLElement)) {
            console.info('AnimatedComponent: empty element')
        }

        this.element = element

        // соединяем state_list, state_status_list, state в один объект
        this.state_storage = {}
        for (const [key, value] of Object.entries(state_list)) {
            let state_list = {}
            for (const state of value) {
                state_list[state] = {
                    name: state,
                    class: `${this._options.class_prefix}${state}`
                }
            }
            let proccess_suffix = this._options.proccess_suffix
            let state_group = {
                state_list,
                getList() {
                    return Object.keys(this.state_list)
                },
                getClassList() {
                    return Object.values(this.state_list).map(state => state.class)
                },
                getClassListFull() {
                    return [
                        ...Object.values(this.state_list).map(state => state.class),
                        ...Object.values(this.state_list).map(state => state.class + proccess_suffix)
                    ]
                },
                getCurrent() {
                    return ( this.current_state_name ) ? this.state_list[this.current_state_name] : {}
                },
                current_state_name: ( state_active_list[key] !== undefined && value.includes(state_active_list[key]) ) ? state_active_list[key] : '',
                previous_state_name: '', 
                is_in_process: false, 
                status: ( state_status_list.key !== undefined ) ? state_status_list.key : true
            }
            this.state_storage[key] = state_group

            // за одно приводим в соответствие классы DOM
            if ( state_group.current_state_name ) this.element.classList.add( state_group.state_list[state_group.current_state_name].class )
        }
        window.state_storage = this.state_storage
    }

    _getProcessID() {
        if (this.processID === undefined) this.processID = 0
        return ++this.processID
    }

    _animate(anim_target_element, trigger_function, animation_type = 'animation', time_limit = 1500, id = null) {
        return new Promise(
            (resolve) => {
                // если нет элемента
                if (!anim_target_element) {
                    trigger_function()
                    return resolve(true)
                }

                // если элемент не видим
                if (typeof is_hide !== 'undefined') {
                    if (is_hide(anim_target_element)) {
                        trigger_function()
                        return resolve(true)
                    }
                }

                function handler(e) {
                    e.preventDefault()
                    if (e.target !== anim_target_element) {
                        return false
                    }
                    anim_target_element.removeEventListener(event_type, handler)
                    clearTimeout(timer_id)
                    return resolve(true)
                }

                if (!['animation', 'transition'].includes(animation_type)) {
                    animation_type = 'animation'
                }
                let event_type = (animation_type === 'transition') ? 'transitionend' : 'animationend'
                time_limit = time_limit !== null ? time_limit : 1500
                let timer_id = setTimeout(() => {
                    id ? console.error(`${id} exit by timeout`) : console.error('exit by timeout')
                    return resolve(false)
                }, time_limit)
                anim_target_element.addEventListener(event_type, handler)
                window.requestAnimationFrame(trigger_function)
            }
        )
    }

    _getStateGroup(state_group_name) {
        let state_group = this.state_storage[state_group_name]
        if ( !state_group ) {
            console.error(`unknown state group name ${state_group_name}`)
        }

        return state_group
    }

    _getState(state_group_name, state_name=null) {
        let state_group = this._getStateGroup(state_group_name)
        let current_state_name = this.state_storage[state_group_name].current_state_name
        let state = (state_name) ? this.state_storage[state_group_name].state_list[state_name] : this.state_storage[state_group_name].state_list[current_state_name]
        if ( !state ) {
            if (state_name) {
                console.error(`unknown state name ${state_name}`)
                console.info(state_group)
            }
        }

        return state
    }

    _setState(state_group_name, state_name, is_in_process) {
        let state_group = this._getStateGroup(state_group_name)
        if (!state_group) return false

        let new_state = this._getState(state_group_name, state_name)
        let new_state_class_name = (is_in_process) ? new_state.class + this._options.proccess_suffix : new_state.class

        // если состояние отличается от предыдущего - запоминаем
        if ( state_group.current_state_name !== state_name ) {
            state_group.previous_state_name = state_group.current_state_name
        }

        // удаляем другие классы из этой группы кроме нового
        for (let class_name of state_group.getClassListFull()) {
            if ( class_name === new_state_class_name ) continue
            this.element.classList.remove(class_name)
        }

        this.element.classList.add( new_state_class_name )
        state_group.current_state_name = state_name
        state_group.is_in_process = is_in_process
        
    }

    _isInProcess(state_group_name) {
        let state_group = this._getStateGroup(state_group_name)
        let in_process = (state_group) ? state_group.is_in_process : false
        return in_process
    }

    _dispatchEvent( element, event_name, detail ) {
        if (!element || !(element instanceof HTMLElement)) {
            console.error('dispatch event error. Element is empty')
            return false
        }
        element.dispatchEvent(new CustomEvent(event_name, {
            bubbles:true,
            cancelable:true,
            detail
        }))
    }

    addEventListener(eventType, handler, ...args) {
        this.element.addEventListener(eventType, handler, ...args)
    }

    changeState(state_group_name, state_name, target_element = null, animate = true, id = null) {
        if (!id) id = `${this._getProcessID()} ${state_group_name} ${state_name}`

        // если группы нет
        if (!this.state_storage[state_group_name]) {
            console.error(`${id} unknown state_name group ${state_group_name}`)
            return new Promise((resolve) => resolve(false))
        }
        // если группа выключена
        if (this.state_storage[state_group_name].status === false) {
            return new Promise((resolve) => resolve(false))
        }
        // если нет состояния
        if (!this.state_storage[state_group_name].getList().includes(state_name)) {
            console.error(`${id} unknown state_name ${state_name}`)
            return new Promise((resolve) => resolve(false))
        }
        // если уже в этом состоянии
        if (this.state_storage[state_group_name].current_state_name === state_name) {
            return new Promise((resolve) => {
                resolve(false)
            })
        }
        // если в процессе переключения состояний
        if (this._isInProcess(state_group_name)) {
            return new Promise((resolve) => {
                resolve(false)
            })
        }
        
        this._dispatchEvent(target_element || this.element, 'beforeChangeState', {...this._options.detail, state_name})

        let trigger = () => {
            this._setState( state_group_name, state_name, true )
        }
        
        if (!animate) {
            return new Promise(
                (resolve) => {
                    trigger()
                    return resolve(true)
                }
            )
                .then((status) => {
                    this._setState(state_group_name, state_name, false)
                    this._dispatchEvent(target_element || this.element, 'afterChangeState', {...this._options.detail, state_name})
                    return true
                })
                
        } else {
            return this._animate(target_element, trigger, null, null, id)
                .then((status) => {
                    if (!status) {
                        console.error(target_element)
                    }
                    this._setState(state_group_name, state_name, false)
                    this._dispatchEvent(target_element || this.element, 'afterChangeState', {...this._options.detail, state_name})
                    return true
                })
        }

    }

    toggleState(state_group_name, target_element = null, animate = true, id = null) {
        let state_group = this._getStateGroup(state_group_name)
        if (!state_group) return false

        let current_state_name = state_group.current_state_name
        let current_state_index = state_group.getList().indexOf(current_state_name)
        let next_state_index = (current_state_index === state_group.getList().length - 1) ? 0 : current_state_index + 1
        let next_state = state_group.getList()[next_state_index]
        return this.changeState(state_group_name, next_state, target_element, animate, id)
    }

    changeStateStatus(state_group_name, status) {
        status = !!status
        let state_group = this._getStateGroup(state_group_name)
        if (!state_group) return false
        if (state_group.status !== status) {
            if (!status) {
                // при выключении сбрасываем компонент к началному состоянию
                state_group.getClassListFull().forEach(class_name => {
                    this.element.classList.remove(class_name)
                })
                state_group.current = null
            }
            state_group.status = status
        }
    }

    changeStateStatusAll( status ) {
        Object.keys(this.state_storage).forEach((state_group_name) => {
            this.changeStateStatus(state_group_name, status)
        });
    }
}

export default AnimatedComponent